import React, { useEffect } from 'react';

export const SessionKEY = {
  petInsureProcessApiInfo: 'petInsureProcessApiInfo',
  sysOption: 'sysOption'
} as const;

export function useStickyState<T> (defaultValue: false, key: typeof SessionKEY[keyof typeof SessionKEY]) {
  const [value, setValue] = React.useState(() => {
    const stickyValue = window.sessionStorage.getItem(key);

    return stickyValue !== null
      ? JSON.parse(stickyValue) as T
      : defaultValue;
  });

  useEffect(() => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return { value, setValue };
  // return [value, setValue];
}
